import { render, staticRenderFns } from "./openChat.vue?vue&type=template&id=c38c1ffa&scoped=true"
import script from "./openChat.vue?vue&type=script&lang=js"
export * from "./openChat.vue?vue&type=script&lang=js"
import style0 from "./openChat.vue?vue&type=style&index=0&id=c38c1ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38c1ffa",
  null
  
)

export default component.exports